/**
 * Default makeup schedule start times configuration
 * These defaults are used when no custom configuration exists for a given date
 */

// Default start times for different day types (must match server defaults in makeup_helper.js)
export const DEFAULT_MAKEUP_START_TIMES = {
  // Monday through Friday default start times
  weekday: ['20:00'],

  // Saturday default start times
  saturday: ['16:00', '18:00', '20:00'],

  // Sunday default start times (when Sunday scheduling is allowed)
  sunday: ['13:00', '17:00']
};

// Time range constraints for makeup scheduling
export const MAKEUP_TIME_RANGE = {
  // Earliest possible start time
  start: { hour: 13, minute: 0 },
  
  // Latest possible end time
  end: { hour: 22, minute: 30 }
};

// Time slot duration in minutes
export const MAKEUP_SLOT_DURATION = 30;

/**
 * Helper function to format default times for display
 * @param {string} dayType - 'weekday', 'saturday', or 'sunday'
 * @returns {string} Formatted string of default times
 */
export const formatDefaultTimes = (dayType) => {
  const times = DEFAULT_MAKEUP_START_TIMES[dayType];
  if (!times || times.length === 0) return 'None';
  return times.join(', ');
};

/**
 * Get appropriate default times based on day of week
 * @param {number} weekday - Day of week (1-7, where 1 is Monday and 7 is Sunday)
 * @param {boolean} allowSunday - Whether Sunday scheduling is allowed
 * @returns {string[]} Array of default start times
 */
export const getDefaultTimesForDay = (weekday, allowSunday = false) => {
  if (weekday === 7) { // Sunday
    return allowSunday ? DEFAULT_MAKEUP_START_TIMES.sunday : [];
  } else if (weekday === 6) { // Saturday
    return DEFAULT_MAKEUP_START_TIMES.saturday;
  } else { // Weekdays (1-5)
    return DEFAULT_MAKEUP_START_TIMES.weekday;
  }
};